import { StoreConfig, Store, akitaConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { UserInfoDto } from '@app-model/user';

export interface UserInfo {
	id: string;
	name: string;
	email: string;
	hasPlan: boolean;
	firstName: string;
}

export interface SessionState {
	isAuthenticated: boolean;
	userInfo: UserInfoDto | null;
}

export function createInitialState(): SessionState {
	return {
		isAuthenticated: false,
		userInfo: null
	};
}

akitaConfig({
  resettable: true
})

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'sessionState' })
export class SessionStore extends Store<SessionState> {
	constructor() {
		super(createInitialState());
	}

	clearSession(): void {
		this._setState(state => createInitialState());
	}

	updateStatusPlan(status: boolean) {
		this.update(state => {
			return {
				...state,
				userInfo: {
					...state.userInfo,
					hasPlan: status
				}
			};
		});
	}
}
